import NewsRoomBlogTabs, { NewsRoomBlogTabsProps } from "./NewsRoomBlogTabs";

export { NewsRoomBlogTabs, NewsRoomBlogTabsProps };

export default NewsRoomBlogTabs;
